import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Tooltip,
  IconButton,
} from '@mui/material';
import { Add, Edit, Visibility } from '@mui/icons-material';
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';
import { listConfigPublicacoes, ConfigPublicacao } from '../../services/configPublicacoesService';
import useAuth from '../../hooks/useAuth';

const ConfigPubList: React.FC = () => {
  const [configs, setConfigs] = useState<ConfigPublicacao[]>([]);
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const fetchConfigs = async () => {
    setLoading(true);
    try {
      const data = await listConfigPublicacoes();
      setConfigs(data);
    } catch (error) {
      console.error('Erro ao listar configurações:', error);
      swal('Erro', 'Não foi possível listar as configurações de publicações.', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfigs();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h5">Configurações de Publicações</Typography>
        {user?.is_system_admin && (
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => navigate('/configuracoes-publicacoes/novo')}
          >
            Nova Configuração
          </Button>
        )}
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID da Entidade</TableCell>
              <TableCell>Prefixo</TableCell>
              <TableCell>Sufixo</TableCell>
              <TableCell>Tipo</TableCell>
              <TableCell>Gestor</TableCell>
              <TableCell>Editor</TableCell>
              <TableCell align="right">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {configs.map((cfg) => (
              <TableRow key={cfg.id}>
                <TableCell>{cfg.id}</TableCell>
                <TableCell>{cfg.prefix}</TableCell>
                <TableCell>{cfg.suffix}</TableCell>
                <TableCell>{cfg.type}</TableCell>
                <TableCell>{cfg.manager_name}</TableCell>
                <TableCell>{cfg.editor_name}</TableCell>
                <TableCell align="right">
                  <Tooltip title="Ver Detalhes">
                    <IconButton onClick={() => navigate(`/configuracoes-publicacoes/${cfg.id}`)}>
                      <Visibility />
                    </IconButton>
                  </Tooltip>
                  {user?.is_system_admin && (
                    <Tooltip title="Editar">
                      <IconButton onClick={() => navigate(`/configuracoes-publicacoes/${cfg.id}/editar`)}>
                        <Edit />
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {configs.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  Nenhuma configuração encontrada.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ConfigPubList;
